/**
 * Created by Languagenut on 11/12/2019.
 */

import React from 'react';
import Content from  './content_select.js';
import {Button, Breadcrumb, Card, Row, Col} from 'react-bootstrap'
import VocabContent from './vocab_content.js';
import contentService from '../../../services/content-service.js';
import HomeworkStore from '../../../store/homework-store';
import Translation from '../../../store/internationalization-store';
import SentenceContent from './sentence_content.js';
import VerbContent from './verb_content.js';
import InformationPopup from '../../popup/information_popup.js'

export default class ContentSelection extends  Content.component {

    constructor(props) {
        super(props);
        this.props = {};
        this.props.data = {};
    }

    componentWillReceiveProps(props){

        this.props = props;

        if(this.props)
        {
            if(this.props.data)
            {
                this.props.data.isMake = true;
                this.props.data.type = this.props.data.types[this.props.data.counter];
            }
        }

        this.setState({
            currentSelected: undefined,
        })

        this.componentDidMount();
    }

    menuItem(data){
        var examStuff = this.exam_initial_uid;
        var allowCheck = true;

        var selectData = function() {
            if (data.originalTitleExam != undefined) {
                contentService.getExamProper(examStuff, data.originalTitleExam).then(
                    function(response) {
                        this.setState({information:true, informationText:response.translation.translation_uid})
                    }.bind(this))
            } else {
                this.selectIntialData(data)
            }
        }.bind(this);

        if (data.title == "Speak First") {
            data.title = "Speak First - Please do not assign Reading or Writing Skills in this area";
        }

        if (data.subModules == undefined || data.isLast) {
            return <Col md={6} >  <Card  onClick={function() {
                                allowCheck = false;
                                selectData();
                            }}body><Row>
                <Col sm={{span: 11, offset: 0}}>
                            <span className="float-left"><i onClick={function() {
                                allowCheck = false;
                                selectData();
                            }}  className={(data.subModules == undefined || data.isLast) ? "hyperlink hyperlink_black fas fa-info-circle" : ""}></i>&nbsp;{data.title}</span>

                </Col>

            </Row></Card> <br/></Col>
        } else {
            return <Col md={6} >  <Card body><Row onClick={function() {this.selectIntialData(data)}.bind(this)}>
                <Col sm={{span: 11, offset: 0}}><span className="float-left">{data.title}</span></Col>
                <Col sm={{span: 1, offset: 0}}><span className="float-right"> <i className={(data.subModules == undefined || data.isLast) ? "" : "fas fa-chevron-right"}></i></span></Col>
            </Row></Card> <br/></Col>
        }
    }

    render(){

        console.log(this.state.currentData )
        if (this.state.currentData == undefined) {
            return "";
        }

        var currentPage = "";
        var popoutPage = "";
        var showPopout = true;


        console.log(this.props.data.type)
        if (this.props.data.type.indexOf("vocabs") > -1  || this.props.data.type == "custom") {
            currentPage = this.viewVocab.bind(this)();
        } else if (this.props.data.type == "sentences") {
            currentPage = this.viewSentence.bind(this)();
        } else if (this.props.data.type == "grammar") {
            currentPage = this.viewSentence.bind(this)();
        } else if (this.props.data.type == "verbs") {
            currentPage = this.viewVerb.bind(this)();
        } else if (this.props.data.type == "exam") {
            currentPage = this.viewExam.bind(this)();
        }

        if (this.state.selectedType == "") {
            showPopout = false;
        } else if (this.state.selectedType == "vocabs" || this.state.selectedType == "custom") {
            console.log(this.state.contentData)
            popoutPage = <VocabContent disableCheck={true} vocabTranslations={this.state.contentData}></VocabContent>
        } else if (this.state.selectedType == "sentences") {
            popoutPage = <SentenceContent disableCheck={true}  sentenceTranslations={this.state.contentData}></SentenceContent>
        } else if (this.state.selectedType == "grammar") {
            popoutPage = <SentenceContent disableCheck={true}  sentenceTranslations={this.state.contentData}></SentenceContent>
        } else if (this.state.selectedType == "verbs") {
            popoutPage = <VerbContent disableCheck={true}  verbTranslations={this.state.contentData}></VerbContent>
        } else if (this.state.selectedType == "exam") {
            //popoutPage = <ExamContent verbTranslations={this.state.contentData}></VerbContent>
        }

        var newOnClick = function() {
            var selectedData = this.getSelectedValues();
            HomeworkStore.setSelectedMassData(selectedData);
            this.props.forceAdvance();
        }.bind(this);

        var AdvanceButton = React.createElement(Button, {
            onClick: newOnClick,
            bsStyle:'primary',
            className:"btn-block",
            disabled:this.getSelectedValues().length < 1
        },Translation.get(631 ,'Next'));

        return <div>
            <InformationPopup title={Translation.get(12291 , 'Preview')} show={showPopout} onHide={()=>{
                    this.setState({selectedType:""})
                }}>
                {popoutPage}
            </InformationPopup>
            <InformationPopup title={Translation.get(12722 , 'Learning outcomes')} show={this.state.information} onHide={()=>{this.setState({information:false})}}>
                {Translation.get(this.state.informationText , 'learningOutcome here')}
            </InformationPopup>
            <Row>
                <Col md={12}>

                        <Breadcrumb bsPrefix="breadcrumb breadcrumb2">
                            {this.buildBreadCrumbs()}
                        </Breadcrumb>

                        <Row>
                            {currentPage}
                        </Row>

                </Col>
            </Row>
        </div>;


    }

}
